/**
 * Extracts the last (most recent) comment from a pipe-separated comment string.
 * Backend stores comments as pipe-separated strings with newest comment first:
 * "newest_comment|older_comment|oldest_comment"
 *
 * @param comments - Pipe-separated comment string or null/undefined
 * @returns The first comment (newest) or empty string if no comments
 */
export function getLastComment(comments: string | null | undefined): string {
  if (!comments) return '';
  const parts = comments.split('|');
  return parts[0]?.trim() || '';
}
